/* unplugin-vue-components disabled */import { render } from "./IndexInfoActivity.vue?vue&type=template&id=31a9f451&scoped=true"
import script from "./IndexInfoActivity.vue?vue&type=script&lang=js"
export * from "./IndexInfoActivity.vue?vue&type=script&lang=js"

import "./IndexInfoActivity.vue?vue&type=style&index=0&id=31a9f451&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a9f451"]])

export default __exports__